<section class="form-layout-2">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-xs-12">
        <app-title [titles]="[title()]" class="title" />
      </div>
      <div class="col-lg-8 col-xs-12 content">
        <p class="paragraph">Peut-être le début de votre nouvelle aventure professionnelle !</p>
        <p class="paragraph">
          Vous recevrez prochainement un email vous invitant à vous connecter à votre espace candidat.
        </p>
        <p class="paragraph">
          Notre équipe développement Franchise, vous recontactera dans un délai de 48H pour faire plus ample
          connaissance et échanger sur votre projet.
        </p>
        <p class="paragraph">À très bientôt.</p>
        <div class="buttons">
          <app-button
            [icon]="{ name: 'CHEVRON_RIGHT', color: 'BLACK' }"
            [theme]="'WHITE'"
            [url]="'/savoir-faire'"
            class="button"
            label="Le métier d'agenceur" />

          <app-button
            [icon]="{ name: 'CHEVRON_RIGHT', color: 'WHITE' }"
            [theme]="'TRANSPARENT_WHITE'"
            [url]="'/realisations'"
            label="Le beau selon Perene" />
        </div>
      </div>
    </div>
  </div>
</section>
